<div class="container">
  <img src="assets/images/punteggi.jpg" class="img-fluid" alt="">
  <div class="row mt-5">
    <div class="col-10 offset-1 text-center mt-5" *ngIf="!punteggio">
      <div *ngIf="localStorage.getItem('l') === 'it'">
        <h4> Non hai ancora guadagnato nessun punto!</h4>
        <p *ngIf="!punteggio"> Inquadra i QR Code per iniziare a giocare</p>
      </div>

      <!--ENG-->
      <div *ngIf="localStorage.getItem('l') === 'en'">
        <h4> You haven't earned any points yet!</h4>
        <p *ngIf="!punteggio"> Scan the QR Codes to start playing</p>
      </div>

      <!--FRA-->
      <div *ngIf="localStorage.getItem('l') === 'fr'">
        <h4> Vous n'avez pas encore gagné de points!</h4>
        <p *ngIf="!punteggio"> Scannez les codes QR pour commencer à jouer</p>
      </div>


    </div>
    <div class="col-10 offset-1 text-center" *ngIf="punteggio">
      <!--ITA-->

      <div *ngIf="localStorage.getItem('l') === 'it'">
        <h1 class="text-primary mb-3">Complimenti!</h1>
        <h2>Hai guadagnato <br>
          <span class="text-secondary">{{punteggio}} punti</span>
        </h2>
        <p class="mt-3">Continua a giocare inquadrando altri <br>QR Code!</p>
      </div>

      <!--ENG-->
      <div *ngIf="localStorage.getItem('l') === 'en'">

        <h1 class="text-primary mb-3">Congrats!</h1>
        <h2>You earned <br>
          <span class="text-secondary">{{punteggio}} points</span>
        </h2>
        <p class="mt-3">Continue playing by scanning other <br>QR Codes!</p>
      </div>


      <!--FRA-->
      <div *ngIf="localStorage.getItem('l') === 'fr'">

        <h1 class="text-primary mb-3">Félicitations!</h1>
        <h2>Vous avez gagné <br>
          <span class="text-secondaire">{{punteggio}}points</span>
        </h2>
        <p class="mt-3">Continuez à jouer en scannant d'autres <br>codes QR!</p>
      </div>


    </div>


  </div>
</div>

